import { useState } from 'react';
import { Label } from '~/components/ui/label';
import { Switch } from '~/components/ui/switch';
import { useSetGuardianReceivesEmails } from './useSetGuardianReceivesEmails';

interface GuardianEmailsToggleProps {
  familyId: string;
  personId: string;
  receivesEmails: boolean;
  onChanged?: () => void;
}

export function GuardianEmailsToggle({ familyId, personId, receivesEmails, onChanged }: GuardianEmailsToggleProps) {
  const [setReceivesEmails, { loading }] = useSetGuardianReceivesEmails();
  const [error, setError] = useState<string | null>(null);
  const id = `receives-emails-${personId}`;

  const handleChange = async (checked: boolean) => {
    setError(null);
    try {
      const result = await setReceivesEmails({ variables: { familyId, personId, receivesEmails: checked } });
      const errors = result.data?.setGuardianReceivesEmails?.errors ?? [];
      if (errors.length > 0) {
        setError(errors.join(', '));
        return;
      }
      onChanged?.();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Unable to save this setting.');
    }
  };

  return (
    <div>
      <div className="flex items-center gap-2">
        <Switch id={id} checked={receivesEmails} disabled={loading} onCheckedChange={handleChange} />
        <Label htmlFor={id} className="text-xs">Gets family emails</Label>
      </div>
      {error && (
        <p role="alert" className="mt-1 text-xs text-destructive">{error}</p>
      )}
    </div>
  );
}
